export const T = {
  en_GB: {
    title: "Member links",
    description:
      "Every current member of this group answers for themselves. Send each member their own link. They sign in with a one-time code sent to the member's (or their representative's) e-mail or phone, or with BankID matching the national ID on record.",
    titleRepresentatives: "Representatives",
    descriptionRepresentatives:
      "Several representatives act for this client, so each of them answers for themselves. Send each representative their own link. They sign in with a one-time code sent to their own e-mail or phone, or with BankID matching their national ID.",
    cannotSignInRepresentative: (name: string) =>
      `${name} cannot sign in — add an e-mail address, a mobile number or a national ID to the representative.`,
    openRepresentatives: "Open representatives",
    generateLink: "Generate link",
    copy: "Copy",
    linkCopied: "Link copied to clipboard!",
    sendEmail: "Send e-mail",
    sendSms: "Send SMS",
    revoke: "Revoke",
    revokeTitle: "Revoke personal link",
    revokeDescription: (name: string) =>
      `The existing link for ${name} will no longer work. Continue?`,
    revokeConfirm: "Revoke",
    cancel: "Cancel",
    notLinkedHint: (name: string) => `Link ${name} to an existing client to give them a link.`,
    linkToClient: "Link to a client",
    noSsnNote: "No national ID on record — signs in with a one-time code.",
    cannotSignIn: (name: string) =>
      `${name} cannot sign in — add contact details or a national ID to the linked client.`,
    openLinkedClient: "Open client",
    representativeLink: (representative: string, member: string) =>
      `Link is for ${representative} on behalf of ${member}.`,
    groupLinkNotLive:
      "Member links are unavailable until the group's access link is generated and active.",
    publicAccessNotEnabledHint: "Enable public access for this flow before issuing member links.",
    noEmailHint: "Add an e-mail address to send an e-mail invite.",
    noPhoneHint: "Add a phone number to send an SMS invite.",
    instanceNotEditableHint: "This flow can no longer be changed.",
    genericError: "Something went wrong. Please try again.",
    inviteSent: "Invite sent.",
    statusNotLinked: "Not linked",
    statusNoLink: "No link yet",
    statusLinkReady: "Link ready",
    statusUnavailable: "Link unavailable",
    statusInvited: (channel: string, date: string) => `Invited via ${channel} at ${date}`,
    statusLastSignedIn: (date: string) => `Last signed in ${date}`,
    channelEmail: "e-mail",
    channelSms: "SMS",
    loadFailed: "Could not load member links. Please try again.",
  },
  nb_NO: {
    title: "Medlemslenker",
    description:
      "Hvert nåværende medlem av denne gruppen svarer for seg selv. Send hvert medlem sin egen lenke. De logger inn med en engangskode sendt til medlemmets (eller representantens) e-post eller telefon, eller med BankID som samsvarer med registrert fødselsnummer.",
    titleRepresentatives: "Representanter",
    descriptionRepresentatives:
      "Flere representanter handler for denne kunden, så hver av dem svarer for seg selv. Send hver representant sin egen lenke. De logger inn med en engangskode sendt til sin egen e-post eller telefon, eller med BankID som samsvarer med eget fødselsnummer.",
    cannotSignInRepresentative: (name: string) =>
      `${name} kan ikke logge inn — legg inn en e-postadresse, et mobilnummer eller et fødselsnummer på representanten.`,
    openRepresentatives: "Åpne representanter",
    generateLink: "Generer lenke",
    copy: "Kopier",
    linkCopied: "Lenke kopiert til utklippstavlen!",
    sendEmail: "Send e-post",
    sendSms: "Send SMS",
    revoke: "Tilbakekall",
    revokeTitle: "Tilbakekall personlig lenke",
    revokeDescription: (name: string) =>
      `Den eksisterende lenken for ${name} vil ikke lenger fungere. Fortsette?`,
    revokeConfirm: "Tilbakekall",
    cancel: "Avbryt",
    notLinkedHint: (name: string) =>
      `Koble ${name} til en eksisterende kunde for å gi dem en lenke.`,
    linkToClient: "Koble til en kunde",
    noSsnNote: "Ingen nasjonal ID registrert — logger inn med engangskode.",
    cannotSignIn: (name: string) =>
      `${name} kan ikke logge inn — legg inn kontaktopplysninger eller fødselsnummer på den koblede kunden.`,
    openLinkedClient: "Åpne kunde",
    representativeLink: (representative: string, member: string) =>
      `Lenken er for ${representative} på vegne av ${member}.`,
    groupLinkNotLive:
      "Medlemslenker er utilgjengelige til gruppens tilgangslenke er generert og aktiv.",
    instanceNotEditableHint: "Denne flyten kan ikke lenger endres.",
    publicAccessNotEnabledHint:
      "Aktiver offentlig tilgang for denne flyten før du utsteder medlemslenker.",
    noEmailHint: "Legg til en e-postadresse for å sende e-postinvitasjon.",
    noPhoneHint: "Legg til et telefonnummer for å sende SMS-invitasjon.",
    genericError: "Noe gikk galt. Prøv igjen.",
    inviteSent: "Invitasjon sendt.",
    statusNotLinked: "Ikke koblet",
    statusNoLink: "Ingen lenke ennå",
    statusLinkReady: "Lenke klar",
    statusUnavailable: "Lenke utilgjengelig",
    statusInvited: (channel: string, date: string) => `Invitert via ${channel} ${date}`,
    statusLastSignedIn: (date: string) => `Sist innlogget ${date}`,
    channelEmail: "e-post",
    channelSms: "SMS",
    loadFailed: "Kunne ikke laste medlemslenker. Prøv igjen.",
  },
} as const;
